import React from 'react';
import { ImageBackground, StatusBar, View } from 'react-native';
import { t } from 'Locale';
// eslint-disable-next-line import/no-unresolved
import { Button } from 'LocalGluons';
// eslint-disable-next-line import/no-unresolved
import { getAssetImageUrl, prependZero } from 'Utils';
import { Device } from 'DeviceUtils';
import { ContinueWatchingItem } from '@24i/st-api-connector';
import type { PlayerData } from 'Types';
import PlayerHeader from '../../../PlayerUI/components/PlayerHeader';

import defaultStyles from './ContinueWatchingDialog.jss';

const getTimeStringFromMillis = (millis) => {
    const seconds = Math.floor(millis / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(seconds / 3600);

    return `${prependZero(hours)}:${prependZero(minutes - hours * 60)}:${prependZero(
        seconds - minutes * 60
    )}`;
};

interface ContinueWatchingDialogProps {
    item: PlayerData['item'];
    continueWatchingData: ContinueWatchingItem;
    onContinue: () => void;
    onBack: () => void;
    onRestart: () => void;
}

const ContinueWatchingDialog = ({
    item,
    continueWatchingData,
    onContinue,
    onBack,
    onRestart
}: ContinueWatchingDialogProps): React.ReactElement => (
    <View style={[defaultStyles.container, Device.isWeb && { width: '100%', height: '100%' }]}>
        <StatusBar hidden />
        <ImageBackground
            style={defaultStyles.previewImage}
            source={{ uri: getAssetImageUrl(item, 'PREVIEW') }}
        >
            <View style={defaultStyles.buttonsContainer}>
                <Button
                    isSecondary
                    title={`${t('COMMON.CONTINUE_WATCHING')} (${getTimeStringFromMillis(
                        continueWatchingData.stopTimeInMillis
                    )})`}
                    onPress={onContinue}
                    iconName="play_arrow_player"
                />
                <Button
                    isSecondary
                    title={t('COMMON.RESTART')}
                    onPress={onRestart}
                    iconName="reset"
                />
            </View>
        </ImageBackground>
        <PlayerHeader style={defaultStyles.header} title={item.getTitle()} onBack={onBack} />
    </View>
);
export default ContinueWatchingDialog;
